import { Box } from '@chakra-ui/react'
import { ModerationTile } from './ModerationTile'

// A fixed NxM of slots, filling whatever the toolbar leaves. On a narrow screen
// the configured column count is unusable, so the columns cap at two and the
// grid scrolls instead of squeezing every video into a stamp.

export function ModerationGrid({
  slots,
  rows,
  cols,
  isNarrow,
  focusedIndex,
  onFocus,
  onDecide,
  onFavorite,
  onWatched,
  onRotate,
  onForceVertical,
  showDisplayControls,
  challengeMeta,
  gateWatch,
}) {
  return (
    <Box
      display="grid"
      gridTemplateColumns={`repeat(${isNarrow ? Math.min(cols, 2) : cols}, 1fr)`}
      gridTemplateRows={isNarrow ? undefined : `repeat(${rows}, 1fr)`}
      gridAutoRows={isNarrow ? 'minmax(150px, 42vh)' : undefined}
      gap="2px"
      h={isNarrow ? 'auto' : '100%'}
      overflow={isNarrow ? 'visible' : 'hidden'}
    >
      {slots.map((slot, idx) => (
        <ModerationTile
          key={slot ? `${idx}-${slot.video.id}` : `empty-${idx}`}
          slot={slot}
          focused={idx === focusedIndex}
          onFocus={() => onFocus(idx)}
          onDecide={(accepted) => onDecide(slot.video.id, accepted)}
          onFavorite={() => onFavorite(slot.video.id, slot.video.isFavorite)}
          onWatched={(verified, why) => onWatched(slot.video.id, verified, why)}
          onRotate={() => onRotate(slot.video.id, slot.video.rotation)}
          onForceVertical={() => onForceVertical(slot.video.id, slot.video.forceVertical)}
          showDisplayControls={showDisplayControls}
          challengeMeta={challengeMeta}
          gateWatch={gateWatch}
        />
      ))}
    </Box>
  )
}
